// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"ed3775854c7183112131","339":"7d4e43a51c194b119ab2"}[chunkId] + ".js";
};